import { IColumnVisibility } from "redux/models/reportModels";
import { PageTypeEnum, ReportType } from "./reportDefinitions";
import { IPageSettings } from "./models";

export const getToken = (): string => {
    const storage = getUserLocalStorageData();

    return storage?.data?.token;
};

export const getRefreshToken = () => {
    const storage = getUserLocalStorageData();

    return storage?.data?.refreshToken;
};

function getUserLocalStorageData() {
    const stored = localStorage.getItem("user");
    if (!stored) {
        return undefined;
    }
    return JSON.parse(stored);
}

export function setUserLocalStorageData(data: any) {
    localStorage.setItem(
        "user",
        JSON.stringify({
            data,
        })
    );
}

export function removeUserLocalStorageData() {
    localStorage.removeItem("user");
}

export const setPageSettings = (pageType: PageTypeEnum, columns: IColumnVisibility[], reportType: ReportType) => {
    let pageSettings = getPageSettings(pageType, reportType);

    if (!pageSettings) {
        pageSettings = { columns: [] };
    }
    pageSettings.columns = columns;

    localStorage.setItem(`${pageType}/${reportType}`, JSON.stringify(pageSettings));
};

export const getPageSettings = (pageType: PageTypeEnum, reportType: ReportType): IPageSettings | null => {
    const stored = localStorage.getItem(`${pageType}/${reportType}`);
    if (!stored) {
        return null;
    }

    return Object.assign(new IPageSettings(), JSON.parse(stored));
};

export const setPageSize = (pageSize: number) => {
    localStorage.setItem("pageSize", pageSize.toString());
};

export const getPageSize = (): number => {
    const stored = localStorage.getItem("pageSize");
    if (!stored) {
        return 25;
    }

    return parseInt(stored);
};

export const setRedirectToLastRoute = (value: boolean) => {
    sessionStorage.setItem("redirectToLastRoute", value.toString());
};

export const getRedirectToLastRoute = (): boolean => {
    const stored = sessionStorage.getItem("redirectToLastRoute");
    return /true/i.test(stored || "true"); // default true
};
